// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperPreviewList-cls1_wyO","cls2":"PaperPreviewList-cls2_Mwk PaperPreviewList-cls1_wyO"};